import { useIsIndividualInclusionNamingEnabled } from "src/pages/userGroups/KeyCondition/common/hooks/IsIndividualInclusionNamingEnabled";
import { IndividualInclusionMemberToolTip } from "../../individualInclusionMemberToolTip";
import { TextWithSubTitle } from "../../textWithSubTitle";

export function UserTableColumnGenerator(
  columns,
  individualInclusionMembers,
  sortEnabled = true,
  searchEnabled = true,
  excludedMembers = []
) {
  const isIndividualInclusionNamingEnabled = useIsIndividualInclusionNamingEnabled();

  return columns?.map((column) => {
    let { key, render, ...restKeys } = column;
    if (render === "TextWithSubTitleComponent") {
      render = (content) => {
        return <TextWithSubTitle titles={[content.first, content.second]} />;
      };
    }
    if (key === "user") {
      render = (content, record) => {
        let hasIndividualInclusionMembers = individualInclusionMembers?.indexOf(record.key) > -1;
        let hasExcludedMembers = excludedMembers?.indexOf(record.key) > -1;
        let userName = (
          <>
            <span>{content.first}</span>
            {hasIndividualInclusionMembers === true ? (
              <IndividualInclusionMemberToolTip
                title={
                  isIndividualInclusionNamingEnabled
                    ? "Individual Inclusion member"
                    : "Special member"
                }
              />
            ) : null}
            {hasExcludedMembers === true ? (
              <IndividualInclusionMemberToolTip title={"Excluded member"} isExcluded={true} />
            ) : null}
          </>
        );
        return <TextWithSubTitle titles={[userName, content.second]} />;
      };
    }

    return { render, searchEnabled, sortEnabled, width: 200, ...restKeys };
  });
}
